import { ContentFiles } from '../../../shared/api-models/content';

export class ContentFilesView extends ContentFiles {
	previewUrl: string;
	inRevision: boolean;
}
